import styled from "styled-components";
import { keyframes } from "styled-components";
import React from "react";
import { useTheme } from "../Theme";

interface ISpinnerProps {
  fontSizeModifier?: number;
  style?: object;
}

interface ISpinnerDivProps {
  spinnerColor: string;
}

const spin = keyframes`
0% {
  top: 36px;
  left: 36px;

  width: 0;
  height: 0;

  opacity: 1;
}
100% {
  top: 0px;
  left: 0px;

  width: 72px;
  height: 72px;

  opacity: 0;
}
`;

const LoaderBox = styled.div.attrs(() => ({
  ["data-testid"]: "spinner",
}))<ISpinnerProps>`
  display: grid;
  place-items: center;
  margin: ${props => (props.fontSizeModifier ? 5.5 / props.fontSizeModifier : 5.5)}rem auto;

  width: 100%;
  height: 100%;

  text-align: center;
  font-size: ${props => (props.fontSizeModifier ? 1.1 / props.fontSizeModifier : 1.1)}rem;
`;

const SpinnerContainer = styled.div`
  display: inline-block;
  position: relative;

  width: 80px;
  height: 80px;
`;

const SpinnerDiv = styled.div<ISpinnerDivProps>`
  position: absolute;

  border: 4px solid #000;
  border-radius: 50%;
  border-color: ${props => props.spinnerColor};
  opacity: 1;

  animation: ${spin} 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;

  & ${SpinnerContainer}:nth-child(2) {
    animation-delay: -0.5s;
  }
`;

const Spinner = (props: ISpinnerProps) => {
  const themeContext = useTheme();
  const accentColor = themeContext.theme.colors.headerAccent;
  const [spinnerColor, setSpinnerColor] = React.useState("#64C2FF");

  React.useEffect(() => {
    if (accentColor !== themeContext.theme.colors.defaultTheme) {
      setSpinnerColor(accentColor);
    }
  });

  return (
    <LoaderBox {...props}>
      <SpinnerContainer>
        <SpinnerDiv spinnerColor={spinnerColor} />
        <SpinnerDiv spinnerColor={spinnerColor} />
      </SpinnerContainer>
    </LoaderBox>
  );
};

export default Spinner;
